import { styled } from '@/styled-system/jsx';
import { Anchor } from '@zillow/constellation-10';

export const StyledAnchor = styled(Anchor, {
  base: {
    color: 'black !important',
  },
});
